export default function FormLabel({ title, className }: { title: string; className?: string }) {
	return (
		<label className={`text-ink font-semibold text-[14px] leading-[18px] ${className}`}>
			{title}
		</label>
	);
}
